export default {
  list: []
}